export const WebIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_621_962)">
        <path
          d="M17.232 14.4C17.328 13.608 17.4 12.816 17.4 12C17.4 11.184 17.328 10.392 17.232 9.6H21.288C21.48 10.368 21.6 11.172 21.6 12C21.6 12.828 21.48 13.632 21.288 14.4M15.108 21.072C15.828 19.74 16.38 18.3 16.764 16.8H20.304C19.1414 18.8019 17.2969 20.3184 15.108 21.072ZM14.808 14.4H9.192C9.072 13.608 9 12.816 9 12C9 11.184 9.072 10.38 9.192 9.6H14.808C14.916 10.38 15 11.184 15 12C15 12.816 14.916 13.608 14.808 14.4ZM12 21.552C11.004 20.112 10.2 18.516 9.708 16.8H14.292C13.8 18.516 12.996 20.112 12 21.552ZM7.2 7.2H3.696C4.84637 5.19244 6.68959 3.67349 8.88 2.928C8.16 4.26 7.62 5.7 7.2 7.2ZM3.696 16.8H7.2C7.62 18.3 8.16 19.74 8.88 21.072C6.69392 20.3188 4.85315 18.8018 3.696 16.8ZM2.712 14.4C2.52 13.632 2.4 12.828 2.4 12C2.4 11.172 2.52 10.368 2.712 9.6H6.768C6.672 10.392 6.6 11.184 6.6 12C6.6 12.816 6.672 13.608 6.768 14.4M12 2.436C12.996 3.876 13.8 5.484 14.292 7.2H9.708C10.2 5.484 11.004 3.876 12 2.436ZM20.304 7.2H16.764C16.3879 5.71393 15.8317 4.27933 15.108 2.928C17.316 3.684 19.152 5.208 20.304 7.2ZM12 0C5.364 0 0 5.4 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C4.62902 21.5996 5.95189 22.4835 7.4078 23.0866C8.86371 23.6896 10.4241 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 10.4241 23.6896 8.86371 23.0866 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40042 18.0481 1.5165 16.5922 0.913446C15.1363 0.310389 13.5759 0 12 0Z"
          fill="#17150B"
        />
      </g>
      <defs>
        <clipPath id="clip0_621_962">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
